import { ActionBar, ChakraBox, ChakraFlex, FAIconName } from '@equip.health/ui';

export const OverdueAssessmentsSectionErrorFallback = () => {
  return (
    <ChakraFlex border="none" width="100%">
      <ChakraBox>
        <ActionBar
          barIcon={FAIconName.exclamationTriangleRegular}
          id="overdue-assessments-section-error-fallback"
          text="We were unable to load the patient's overdue assessments. Please try again later."
          variant="critical"
        />
      </ChakraBox>
    </ChakraFlex>
  );
};
